import React, {useCallback} from "react";
import {message} from "antd";
import {useGoogleLogin, useGoogleOneTapLogin} from "@react-oauth/google";
import {StyledButton} from "../../../components/index.jsx";
import {GoogleIcon} from "../../../icons/index.jsx";
import "../username-password-login.css";
import {loginOneTapAuthCodeGoogle, loginOneTapGoogle} from "../../../api/auth/auth.js";

export const GoogleButtonLogin = ({onSuccess, setIsLoginLoading}) => {
    const onGoogleCredentialLogin = useCallback(
        async credentialResponse => {
            setIsLoginLoading(true);
            const user = await loginOneTapGoogle(credentialResponse.credential);

            if (user?.error) {
                return;
            }

            await onSuccess();
            setIsLoginLoading(false);
        },
        [onSuccess, setIsLoginLoading]
    );

    const onGoogleAuthCodeLogin = useCallback(
        async codeResponse => {
            setIsLoginLoading(true);
            const user = await loginOneTapAuthCodeGoogle(codeResponse.code);

            if (user?.error) {
                return;
            }

            await onSuccess();
            setIsLoginLoading(false);
        },
        [onSuccess, setIsLoginLoading]
    );

    useGoogleOneTapLogin({
        onSuccess: onGoogleCredentialLogin,
        onError: () => message.error("שגיאה קרתה במהלך ההתחברות, אנא נסה שוב מאוחר יותר")
    });

    const onGoogleLoginButton = useGoogleLogin({
        onSuccess: onGoogleAuthCodeLogin,
        flow: "auth-code"
    });

    return (
        <div className="login-google-button-container">
            <StyledButton className="google-login-btn" onClick={onGoogleLoginButton}>
                Google
                <GoogleIcon />
            </StyledButton>
        </div>
    );
};
